<template>
  <aside class="rwt-sidebar">
    <div class="rbt-single-widget widget_search mt--40" :class="{ 'widget-white': userLogin }">
      <div class="inner">
        <form class="blog-search blog-search--realtime" role="search" @submit.prevent="searchPosts">
          <input
            v-model="searchQuery"
            type="search"
            :placeholder="$t('Blog.search')"
            :aria-label="$t('Blog.search_label')"
          />
          <button type="submit" class="search-button" :aria-label="$t('Blog.search_label')">
            <Icon name="search" size="20" />
          </button>
        </form>
      </div>
    </div>

    <!-- Start Single Widget -->
    <div class="rbt-single-widget widget_categories mt--40" :class="{ 'widget-white': userLogin }">
      <h3 class="title" :class="{ 'text-black': userLogin }">{{ $t('Blog.categories_title') }}</h3>
      <div class="inner">
        <BlogCategories />
      </div>
    </div>
    <!-- End Single Widget -->

    <!-- Start Single Widget -->
    <div class="rbt-single-widget widget_recent_entries mt--40" :class="{ 'widget-white': userLogin }">
      <h3 class="title" :class="{ 'text-black': userLogin }">{{ $t('Blog.post_title') }}</h3>
      <div class="inner">
        <BlogSidebarPost />
      </div>
    </div>
    <!-- End Single Widget -->

    <!-- Start Single Widget -->
    <div class="rbt-single-widget widget_tag_cloud mt--40" :class="{ 'widget-white': userLogin }">
      <h3 class="title" :class="{ 'text-black': userLogin }">{{ $t('Blog.tags_title') }}</h3>
      <div class="inner mt--20">
        <BlogTags />
      </div>
    </div>
    <!-- End Single Widget -->
  </aside>
</template>

<script>
import Icon from '../icon/Icon'
import BlogCategories from './BlogCategories'
import BlogSidebarPost from './BlogSidebarPost'
import BlogSidebarArchive from './BlogSidebarArchive'
import BlogTags from './BlogTags'

export default {
  name: 'BlogSidebar',
  components: {
    BlogTags,
    BlogSidebarArchive,
    BlogSidebarPost,
    BlogCategories,
    Icon
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  watch: {
    searchQuery(value) {
      this.$emit('search-input', value)
    },
    '$route.query.q': {
      immediate: true,
      handler(value) {
        this.searchQuery = typeof value === 'string' ? value : ''
      }
    }
  },
  methods: {
    searchPosts() {
      const query = this.searchQuery.trim()
      const target = this.$router.resolve({
        path: '/Blog',
        query: query ? { q: query } : {}
      }).route

      if (target.fullPath !== this.$route.fullPath) {
        this.$router.push(target.fullPath)
      }
    }
  },
  computed: {
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>

<style scoped>
.widget-white {
  background: #ffffff !important;
  border: 1px solid #eeeeee !important;
  border-radius: 10px;
}

.widget-white .title {
  margin-top: 0;
  border-bottom: 1px solid #eeeeee;

}
</style>
